import Market from '@/creditflowresearch/domain/Market';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import { adaptFilters } from '@/creditflowresearch/application/ArticlesAndStats/Articles/serverSide/filterAdapter';

type QueryParamValue = string | string[] | null | undefined;

interface IStatsFilterQueryParams {
  products?: QueryParamValue,
  regions?: QueryParamValue,
  markets?: QueryParamValue,
  segments?: QueryParamValue,
}

const getStatsFilterFromQuery = ({ products, regions, markets, segments }: IStatsFilterQueryParams) => {
  const { includedSegmentIds, ...filter } = adaptFilters({
    includedProductIds: Product.getIds(products),
    includedRegionIds: Region.getIds(regions),
    includedMarketIds: Market.getIds(markets),
    includedSegmentIds: Segment.getIds(segments),
  }, { markets, segments });

  return filter;
};

export default getStatsFilterFromQuery;
